<template>
  <!-- collapsed rail -->
  <div
    v-if="!open"
    :style="{ width: '44px', flexShrink: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '18px', padding: '12px 0', borderRight: '1px solid var(--p-content-border-color)', background: 'var(--p-content-background)' }"
  >
    <VTab
      v-for="[v, icon, label] in LEFT_TABS"
      :key="v"
      :id="v"
      :current="null"
      :label="label"
      :icon="icon"
      :badge="tabBadges[v]"
      @select="railSelect(v)"
    />
  </div>

  <!-- expanded pane -->
  <aside
    v-else
    :style="{ width: '292px', flexShrink: 0, display: 'flex', flexDirection: 'row', minHeight: 0, borderRight: '1px solid var(--p-content-border-color)', background: 'var(--p-content-background)' }"
  >
    <div
      :style="{ width: '44px', flexShrink: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '18px', padding: '12px 0', borderRight: '1px solid var(--p-content-border-color)' }"
    >
      <VTab
        v-for="[v, icon, label] in LEFT_TABS"
        :key="v"
        :id="v"
        :current="tab"
        :label="label"
        :icon="icon"
        :badge="tabBadges[v]"
        :title="v === tab ? 'Collapse panel' : label"
        @select="gutterSelect"
      />
    </div>
    <div :style="{ flex: 1, minWidth: 0, minHeight: 0, display: 'flex', flexDirection: 'column' }"><slot /></div>
  </aside>
</template>

<script setup>
// Collapsible tabbed left pane (Filters / Views). Ported from list-edit-shell.jsx
// LeftPane. Emits tab(id) and toggle(open). Content is the default slot.
import VTab from './VTab.vue'

const LEFT_TABS = [
  ['filter', 'sliders-h', 'Filters'],
  ['views', 'bookmark', 'Views'],
]

const props = defineProps({
  open: { type: Boolean, default: true },
  tab: { type: String, default: 'filter' },
  tabBadges: { type: Object, default: () => ({}) },
})
const emit = defineEmits(['tab', 'toggle'])

// Closed-rail tab: pick the tab AND open the pane.
function railSelect(v) {
  emit('tab', v)
  emit('toggle', true)
}
// Open-gutter tab: clicking the active tab collapses; otherwise switches tab.
function gutterSelect(id) {
  if (id === props.tab) emit('toggle', false)
  else emit('tab', id)
}
</script>
